module.exports = __webpack_public_path__ + "static/media/Card.b2328beb.less";


//////////////////
// WEBPACK FOOTER
// ./src/components/Card/Card.less
// module id = 111
// module chunks = 0